import { render, staticRenderFns } from "./Tiptap.vue?vue&type=template&id=4dc472bc&"
import script from "./Tiptap.vue?vue&type=script&lang=js&"
export * from "./Tiptap.vue?vue&type=script&lang=js&"
import style0 from "./Tiptap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports